import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Switch,
  Typography,
} from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { createSvgIcon } from '@mui/material/utils';
import * as React from 'react';

export const XIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
      clipRule="evenodd"
    />
  </svg>,
  'X'
);

const ColoredSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#3683b0',
    '&:hover': {
      backgroundColor: "#3683b0"
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#3683b0',
  },
}));

const user = {
  // Set based on connections in db and saved preferences
  emailFrequency: "asap",
  cohorts: [
    { name: "Cohort 1", notify: true },
    { name: "Cohort 2", notify: false },
    { name: "Cohort 3", notify: true },
  ],
}

export default function NotificationSettingsPanel(props) {
  const {
    open,
    setOpen
  } = props;

  const [emailFrequency, setEmailFrequency] = React.useState(user?.emailFrequency);
  const [cohortSettings, setCohortSettings] = React.useState(user?.cohorts);
  const [saved, setSaved] = React.useState(false);
  const theme = useTheme();

  const handleDialogClose = () => {
    setOpen(false)
  }
  const updateEmailFrequency = (event) => {
    setEmailFrequency(event.target.value)
    setSaved(false)
  }
  const updateCohortSettings = (event) => {
    let updatedCohorts = cohortSettings.map(c => {
      if (c.name === event.target.name) {
        c.notify = !c.notify
      }
      return c
    })
    setCohortSettings(updatedCohorts)
    setSaved(false)
  }
  const handleSave = () => {
    // console.log(`\nEmail frequency updated to: ${emailFrequency}`)
    // cohortSettings.forEach(c => {
    //   if (c.notify) {
    //     console.log(`\nNotifications for ${c.name} are turned ON`)
    //   } else {
    //     console.log(`\nNotifications for ${c.name} are turned OFF`)
    //   }
    // })
    setSaved(true)
  }

  return <div>
    <Dialog
      fullWidth
      maxWidth="sm"
      onClose={handleDialogClose}
      open={open}
      sx={{ zIndex: theme?.custom?.dialogZIndex }}
    >
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: '#1c445b',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          px: 3,
          py: 1
        }}
      >
        <Typography variant="h6">
          Email Notifications Settings
        </Typography>
        <IconButton
          color="inherit"
          onClick={handleDialogClose}
        >
          <XIcon fontSize="small" />
        </IconButton>
      </Box>
      <DialogContent>
        <FormControl sx={{ width: '100%' }}>
          <Typography>Notify me of canvas comments and interview feedback via email:</Typography>
          <RadioGroup
            aria-labelledby="email-frequency-label"
            value={emailFrequency}
            onChange={updateEmailFrequency}
            name="email-frequency-group"
            sx={{
              marginLeft: 5
            }}
          >
            <FormControlLabel key="never" value="never" control={<Radio sx={{ '&.Mui-checked': { color: '#3683b0', } }} />} label="Never" />
            <FormControlLabel key="asap" value="asap" control={<Radio sx={{ '&.Mui-checked': { color: '#3683b0', } }} />} label="When they happen" />
            <FormControlLabel key="day" value="day" control={<Radio sx={{ '&.Mui-checked': { color: '#3683b0', } }} />} label="At end of day" />
          </RadioGroup>
          <Divider variant="middle" sx={{ marginTop: 3, marginBottom: 3, }} />
          <Typography>Listen for activity in:</Typography>

          {cohortSettings?.map((c, i) => {
            return (
              <FormControlLabel key={i} sx={{ marginLeft: 4, marginRight: 10 }} control={
                <ColoredSwitch name={c?.name} checked={c?.notify} onChange={updateCohortSettings} />
              } label={c?.name} />
            )
          })}
        </FormControl>

        <Button disabled={(cohortSettings === user?.cohorts && emailFrequency === user?.emailFrequency) || saved}
          sx={{
            position: 'absolute',
            bottom: 7,
            right: 7,
            bgcolor: '#1c445b',
            '&:hover': {
              backgroundColor: '#3683b0',
            },
          }}
          onClick={handleSave}
          variant="contained">
          Save
        </Button>

      </DialogContent>
    </Dialog>
  </div>
};
